import React, {
	useState,
} from 'react';

import {
	buildTestData,
} from 'Vulture/TestData.js';

const DeleteIntegrationListingModal = (props) => {
	const {
		listingConfigName,
		listingCount,
		childTierNames,
		onConfirm,
		closeModal,
	} = props;

	const [ deleteField, setDeleteField, ] = useState('');
	const [ isDeleting, setIsDeleting, ] = useState(false);

	const deleteConfirmed = deleteField === 'DELETE';

	let warningText = `You are about to permanently delete the integration list configuration "${listingConfigName}"`;
	if (listingCount > 0) {
		warningText += ` and its ${listingCount} listing${listingCount !== 1 ? 's' : ''}`;
	}
	warningText += '. This cannot be recovered.';

	return (
		<div>
			<p>{warningText}</p>
			{childTierNames.length > 0 && (
				<p>{`The following child tiers will also be deleted: ${childTierNames.join(', ')}`}</p>
			)}
			<p>Enter the word &ldquo;DELETE&rdquo; below to continue or Cancel to exit.</p>
			<form onSubmit={async (e) => {
				e.preventDefault();

				if (!deleteConfirmed || isDeleting) {
					return;
				}

				setIsDeleting(true);
				await onConfirm();
			}}>
				<input
					value={deleteField}
					onChange={(e) => {
						setDeleteField(e.target.value);
					}}
					data-testing-info={buildTestData('input--deleteIntegrationConfirm')}
					data-test-id='deleteIntegrationConfirmInput'
				/>
				<button
					className='button'
					onClick={(e) => {
						e.preventDefault();
						closeModal();
					}}
					data-testing-info={buildTestData('button--deleteIntegrationCancel')}
				>
					Cancel
				</button>
				<button
					type='submit'
					className={`button ${deleteConfirmed && !isDeleting ? '' : 'button-disabled no-click'}`}
					data-testing-info={buildTestData('button--deleteIntegrationConfirm')}
					data-test-id='deleteIntegrationConfirmButton'
				>
					{isDeleting ? 'Deleting...' : 'DELETE'}
				</button>
			</form>
		</div>
	);
};

export default DeleteIntegrationListingModal;
